/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useContext } from '@wordpress/element';
import Context from '../context/context';

const Group = props => {
    const context = useContext(Context);
    const { data, groupData, updateGroupData, country } = context;

    const displayChar = (data, i) => {
        const value = 'Median household income';
        if (0 !== i && 1 !== i && 2 !== i && 17 !== i) {
            return (
                <div className="row stat">
                    <div className="name"> {data}</div>
                    <div className="number">
                        {null === groupData[data] ? '***' : ''}
                        {value === data && null !== groupData[data]
                            ? groupData[data].toLocaleString()
                            : groupData[data]}
                    </div>
                </div>
            );
        }
    };

    return (
        <>
            <div className="table">
                <div className="selection">
                    {data &&
                        data
                            .sort((a, b) => a.group.localeCompare(b.group))
                            .map((d, i) => {
                                return (
                                    0 !== i && (
                                        <div
                                            onClick={() =>
                                                updateGroupData(d.group)
                                            }
                                            className={
                                                d.group === country
                                                    ? 'active'
                                                    : ''
                                            }
                                        >
                                            {d.group}
                                        </div>
                                    )
                                );
                            })}
                </div>
                <div className="rows">
                    {Object.keys(groupData).map((data, i) =>
                        displayChar(data, i))}
                </div>
            </div>
        </>
    );
};

export default Group;
